<mat-card
    class="daxa-card total-revenue-card mb-25 border-radius bg-white border-none d-block"
    [class.component-dark-theme]="themeService.isDark()"
>
    <mat-card-content>
        <div class="title">
            <h5>
                Total Rapports
            </h5>
            <div class="number fw-medium lh-1">
                {{totalRapport}}
            </div>
        </div>
        <div class="icon text-center rounded-circle text-white position-relative">
            <img src="assets/images/icons/completed-projects.svg" alt="completed-projects">
        </div>
        <div class="info d-flex align-items-center justify-content-between">
            <span class="sub-title d-block text-body">
                Ce mois
            </span>
            <span class="daxa-up-down-badge position-relative">
                <i class="material-symbols-outlined">
                    trending_up
                </i>
                75%
            </span>
        </div>
    </mat-card-content>
</mat-card>